import { render, staticRenderFns } from "./EmpNtcMdl.vue?vue&type=template&id=338c42dd&"
import script from "./EmpNtcMdl.vue?vue&type=script&lang=js&"
export * from "./EmpNtcMdl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports